<template>
  <div>
    <multiselect
      v-model="negocio"
      :placeholder="$t('forms.negocio.fieldsPlaceholder.descripcion')"
      label="descripcion"
      :disabled="isOnlyView"
      :internal-search="false"
      :clear-on-select="false"
      :allow-empty="false"
      :options-limit="300"
      :options="getNegocioListState"
      @close="onTouch"
      @search-change="findNegocio"
      @select="handleSelected"
    >
    </multiselect>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { baseMixin } from "@/mixins/base";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Multiselect,
  },
  mixins: [baseMixin],
  data() {
    return {
      negocio: null,
      isTouched: false
    }
  },
  props: {
    modelValue: {
      type: [String, Number, Object],
      required: true
    }
  },
  computed: {
    ...mapGetters(['getNegocioListState'])
  },
  methods: {
    ...mapActions(['getNegocioList', 'setNegocioList']),
    async findNegocio(query) {
      const res = await this.getNegocioList({ search: query, page: 1 });
      const { results } = await res.json();

      if (this.isEditView || this.isOnlyView) {
        this.negocio = results.filter(r => r.id === this.modelValue)
      }
      this.setNegocioList(results);
    },
     onTouch() {
      this.isTouched = true;
    },
    handleSelected(value) {
      this.$emit("update:modelValue", value)
      this.$emit('update-rubro', value)
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      async handler(newValue) {
        await this.findNegocio(newValue)
      }
    }
  }
};
</script>
